module.exports = __webpack_public_path__ + "static/media/accident-default-image4.51dcc7cc.jpeg";